import { render, staticRenderFns } from "./travelerInfo.vue?vue&type=template&id=924daa9a&scoped=true&"
import script from "./travelerInfo.vue?vue&type=script&lang=js&"
export * from "./travelerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924daa9a",
  null
  
)

export default component.exports